/// <reference path="../../../../../../typings/index.d.ts" />
module Meevo.Components.Controls {
    "use strict";

    export class MeevoApptEditor implements angular.IDirective {
        restrict = "E";
        scope = true;

        templateUrl = "app/plugins/AppointmentBook/views/directives/Appointment_Editor.html";

        constructor(
            private $mdSidenav: any,
            private editorService: any,
            private $translate: angular.translate.ITranslateService,
            private actions: any,
            private $timeout) {
        }

        link: ng.IDirectiveLinkFn = (scope: any, element: JQuery, attrs: angular.IAttributes) => {
            let $timeout = this.$timeout;
            var toggleSecondary = false;
            scope.toggle = false;
            scope.editorService = this.editorService;
            scope.carouselIndex = 0;

            let handler = function () {
                if (toggleSecondary) {
                    scope.toggleRightInfo();
                    scope.toggle = false;
                }
            };
            angular.element(window).on('orientationchange', handler);

            scope.$on('$destroy', ()=> {
                angular.element(window).off('orientationchange', handler);
            });

            scope.$on("appointmentSaved", function () {
                element.find(".left_editor_column").scrollTop(0);
                scope.toggleRight();
                scope.carouselIndex = 0;
                scope.editorService.unbindHotkeys();
            });

            scope.$on('$stateChangeSuccess', (event, toState, toParams, fromState, fromParams) => {
                if (toState.name === 'appointmentBook') {
                    scope.editorService.bindHotkeys();
                }
            });

            scope.cancel = function () {
                element.find(".left_editor_column").scrollTop(0);
                scope.toggleRight();
                scope.carouselIndex = 0;
                scope.editorService.unbindHotkeys();
            };

            scope.toggleRight = () =>
            {
                this.$mdSidenav('right').close();
                this.actions.CheckForAdjustEditor();
                scope.toggle = false;
            };
            scope.toggleRightInfo = () => {
                scope.toggle = !scope.toggle;
                toggleSecondary = !toggleSecondary;
                this.$mdSidenav('rightInfo').toggle();
            }

            scope.desc = scope.$parent.desc;

            scope.messagePlaceholderUnselectedService = this.$translate.instant("MESSAGE_PLACEHOLDER_UNSELECTED_SERVICE");

            // focus the paying client input field when the editor captures focus (after open transition)
            element.find("#appointmentEditorForm").on("focus", (event) => {
                if (event.relatedTarget) {
                    return;
                }
                $timeout(function () {
                    if (scope.editorService.isInEdit) {
                        //if Notes already selected and user start to type, setting focus again actually removes focus, so need to check if element is already in focus (active element)
                        element.find("textarea#appointmentNotes:not(:focus)").focus();
                    }
                    else {
                        element.find("meevo-type-ahead#opensesame input").focus();
                    }
                });

            });

            scope.isAndroid = device.android();
            scope.isMacos = device.macos();
        }

        static factory(): angular.IDirectiveFactory {
            let directive = ($mdSidenav, editorService, $translate, actions, $timeout) => {
                return new MeevoApptEditor($mdSidenav, editorService, $translate, actions, $timeout);
            };

            directive.$inject = ["$mdSidenav", "AppointmentEditorService", "$translate", "appointmentBookActionsService", "$timeout"];

            return directive;
        }
    }

    angular.module("ApptBookApp")
        .directive("meevoApptEditor", MeevoApptEditor.factory());
}